var map = {
	"./Dashboard.vue": [
		"7277",
		"chunk-cb6e7ade",
		"chunk-4f678ea8"
	],
	"./Graficas/Comparativas.vue": [
		"6604",
		"chunk-cb6e7ade",
		"chunk-042407eb"
	],
	"./Graficas/Datos.vue": [
		"3d48",
		"chunk-cb6e7ade",
		"chunk-e3376d76",
		"chunk-e83b8280"
	],
	"./Graficas/Empleados.vue": [
		"0fe2",
		"chunk-54d64f16"
	],
	"./Graficas/Personas.vue": [
		"5fa3",
		"chunk-cb6e7ade",
		"chunk-55ad672c"
	],
	"./Graficas/Recogidas.vue": [
		"ca9b",
		"chunk-cb6e7ade",
		"chunk-e3376d76",
		"chunk-176d3ac7"
	],
	"./Icons.vue": [
		"9cc6",
		"chunk-2d0f09f3"
	],
	"./Maps.vue": [
		"daba",
		"chunk-59c0bb64"
	],
	"./Notifications.vue": [
		"fda7",
		"chunk-2d23822a"
	],
	"./TableList.vue": [
		"6d0d",
		"chunk-2d0daa98"
	],
	"./Typography.vue": [
		"547e",
		"chunk-a819ae82"
	],
	"./Upgrade.vue": [
		"9198",
		"chunk-2d0e492d"
	],
	"./UserProfile.vue": [
		"4a39",
		"chunk-2d0cb6c9"
	],
	"./auth/Login.vue": [
		"5326",
		"chunk-5f5ff6f1"
	],
	"./auth/Logout.vue": [
		"6f8d",
		"chunk-2d0db312"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;